"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBottomItems = void 0;
var react_intl_1 = require("react-intl");
var messages_1 = require("../../messages");
var types_1 = require("./types");
var messages = messages_1.commonMessages.menu;
var useBottomItems = function () {
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    var items = [
        {
            label: formatMessage(messages.dealerLocator),
            icon: 'location_on',
            to: types_1.FSEAuthRoutes.DEALER_LOCATOR_MAIN,
            testId: 'sidebar-dealer-locator',
        },
        {
            label: formatMessage(messages.contactUs),
            icon: 'support',
            to: types_1.FSEAuthRoutes.CONTACT_US,
            testId: 'sidebar-contact-us',
        },
    ];
    return items;
};
exports.useBottomItems = useBottomItems;
